'use strict';

/**
 * function MyCtrl {
 *   $scope.totalCaixas = [
 *     ['Caixas', 'Qtd'],
 *     ['Conferidas', 11],
 *     ['Nao conferidas', 2]
 *   ];
 * }
 *
 * Index.html
 *  <script type="text/javascript" src="http://www.google.com/jsapi?ext.js"></script>
 *  <script type="text/javascript">
 *    google.load('visualization', '1', {packages: ['corechart']});
 *  </script>
 *
 *
 * view:
 * <pie data="totalCaixas" width="400"></pie>
 *
 * Pie chart directive
 *
 *
 */
frontendApp.directive('area', ['$timeout', function ($timeout) {

  return {
    restrict: 'E',
    template: '<div class="iio-area-chart">' +
      '<i class="icon-spinner icon-spin icon-4x" ng-hide="loaded"></i>' +
      '<div class="chart" ng-show="loaded"></div>' +
      '</div>',
    link: function (scope, element, attrs) {

      scope.loaded = false;

      var chartDiv = $(element).find('.chart');
      var data = null;

      element.css({
        'height': attrs.height
      });

      var drawChart = function () {

        var options = {
          title: attrs.chartTitle,
          'backgroundColor': 'transparent',
          hAxis: {title: attrs.hAxis || ""},
          vAxis: {title: attrs.vAxis || ""},
          'width': '100%',
          'height': '100%',
          animation: {
            duration: 200,
            easing: 'inAndOut'
          }
        };

        chart.draw(data, options);
        scope.loaded = true;
      };

      // Create the data table.
      var chart = new google.visualization.AreaChart(chartDiv[0]);
      scope.$watch(attrs.data, function (value) {
        data = google.visualization.arrayToDataTable(value);
        drawChart();
      }, true);

      google.visualization.events.addListener(chart, 'select', function (e) {
        var selectedItem = chart.getSelection()[0];
        if (selectedItem) {
          var value = data.getValue(selectedItem.row, 0);
          scope.$emit('chartItemSelected', value);
          scope.$apply();
        }
      });

      // If the window resizes, re-draw the chart
      // with the existing data that we have
      $(window).resize(function () {
        drawChart();
        scope.$apply();
      });


    }
  };

}]);

